// Step 18 — Contracts route wrapper.
//
// Reuses the existing ContractsPanel (Step 16) verbatim. This page
// only owns the shell chrome (title, empty state when no workspace).
// No new backend endpoint.

import ContractsPanel from "../ContractsPanel";
import {
  AIEmpty,
  AILoading,
  AIPageHeader,
  AISection,
} from "../shell/AIPrimitives";
import { useAIWorkspace } from "../shell/AIWorkspaceContext";

export default function AIContractsPage() {
  const { loading, activeWorkspace, activeWorkspaceId } = useAIWorkspace();
  if (loading) return <AILoading />;
  if (!activeWorkspaceId) {
    return (
      <>
        <AIPageHeader title="Avtal" />
        <AIEmpty title="Ingen affär vald" />
      </>
    );
  }
  return (
    <>
      <AIPageHeader
        title="Avtal"
        subtitle={activeWorkspace?.organisation_name}
      />
      <AISection>
        <ContractsPanel workspaceId={activeWorkspaceId} />
      </AISection>
    </>
  );
}
